var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 46,
    viewBox: "0 0 78 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_7277",
    "data-name": "Groupe 7277",
    transform: "translate(-124 -165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trac\\xE9_10176",
    "data-name": "Trac\\xE9 10176",
    transform: "translate(142 165)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-6,0H48a4,4,0,0,1,4,4V36a4,4,0,0,1-4,4H-6a4,4,0,0,1-4-4V4A4,4,0,0,1-6,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -6 2 C -7.102798461914062 2 -8 2.897201538085938 -8 4 L -8 36 C -8 37.10279846191406 -7.102798461914062 38 -6 38 L 48 38 C 49.10279846191406 38 50 37.10279846191406 50 36 L 50 4 C 50 2.897201538085938 49.10279846191406 2 48 2 L -6 2 M -6 0 L 48 0 C 50.20914077758789 0 52 1.790859222412109 52 4 L 52 36 C 52 38.20914077758789 50.20914077758789 40 48 40 L -6 40 C -8.209140777587891 40 -10 38.20914077758789 -10 36 L -10 4 C -10 1.790859222412109 -8.209140777587891 0 -6 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_716",
    "data-name": "Rectangle 716",
    width: 78,
    height: 4,
    rx: 1,
    transform: "translate(124 207)",
    fill: "#717171"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygone_17",
    "data-name": "Polygone 17",
    d: "M8.128,1.549a1,1,0,0,1,1.743,0l7.29,12.96A1,1,0,0,1,16.29,16H1.71a1,1,0,0,1-.872-1.49Z",
    transform: "translate(172 176) rotate(90)",
    fill: "#717171"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.47b85c8d5025654f1dacd368bd76045c.svg";
export { ForwardRef as ReactComponent };